import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { DataHandler, ToolboxCard } from 'C4';
import { storageKeys } from 'settings';

import APIHandler from 'config/APIHandler';

export default class Toolbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toolbox: [],
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      DataHandler.checkKey(storageKeys.toolbox, APIHandler.getToolbox(appId))
        .then((res) => {
          const startingValues = [];
          Object.keys(res).map(() => {
            const newObj = {};
            newObj.data = 0;
            newObj.pos = 20;
            return startingValues.push(newObj);
          });
          const toolboxItems = (
            <StaggeredMotion
              defaultStyles={startingValues}
              styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
                ? { data: spring(1, { stiffness: 320, damping: 28 }), pos: spring(0, { stiffness: 320, damping: 28 }) }
                : { data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }), pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
            >
              {styles => (
                <React.Fragment>
                  {res.map((tool, id) => {
                      const {
                        type, title, subtitle, url, itemID, image,
                      } = tool;

                      if (tool.type) {
                        const key = id;
                        return (
                          <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                            <ToolboxCard
                              appId={appId}
                              image={image}
                              key={key}
                              index={key}
                              subtitle={subtitle}
                              title={title}
                              type={type}
                              url={url}
                              itemID={itemID}
                            />
                          </div>
                        );
                      }
                      return null;
                  })}
                </React.Fragment>
              )}
            </StaggeredMotion>);
          this.setState({ toolbox: toolboxItems });
        });
    });
  }

  render() {
    return (
      <div className="toolbox__Grid">
        {this.state.toolbox}
      </div>
    );
  }
}
